import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'
import { Notify, Confirm, Busy, IConfirmParameter } from '@/helpers/notification';
import { NavigationService, INavigationService } from "Services/NavigationService";
import { languageKey } from 'Store/keyStore';
import { Result } from "Models/result";
import path from "Router/path";
import { resfreshToken } from "Services/account/authService";
import { sessionKey } from "Store/keyStore";

import certificateContext, { CertificateState } from "Core/certificates/certificateState";

const _notify = new Notify();
const _confirm = new Confirm();
const _busy = new Busy();

export default defineComponent({
    data() {
        const navigationService: INavigationService = new NavigationService(this.$router);
        return {
            notify: _notify,
            navigationService: navigationService
        }
    },
    computed: {
        ...mapGetters({
            locale: languageKey.LOCALE,
            certificate: sessionKey.USER_TOKEN
        }),
    },
    methods: {
        confirm(para: IConfirmParameter) {
            return _confirm.show(para);
        },
        setIsBusy() {
            _busy.setIsBusy();
        },
        clearIsBusy() {
            _busy.clearIsBusy();
        },
        isBusy() {
            return _busy.isBusy();
        },
        async executeAsync(func: () => Promise<Result<any>>): Promise<void> {
            this.setIsBusy();
            try {
                const state = certificateContext.getState();
                if (state.getState() == CertificateState.NoAuthorized) {
                    this.clearIsBusy();
                    this.goToLogin();
                    return;
                }

                if (state.getState() == CertificateState.Expired) {
                    this.clearIsBusy();
                    this.refreshCetificate();
                    return;
                }

                const result = await func();
                if (result && !result.isSuccess && !result.isAuthorized) {
                    // if (sessionService.has()) {
                    //     this.refreshCetificate();
                    // } else {
                    //     this.clearIsBusy();
                    //     this.goToLogin();
                    // }
                } else {
                    this.clearIsBusy();
                }
            } catch (error) {
                console.error(error);
                this.clearIsBusy();
            }
        },
        async refreshCetificate() {
            const result = await resfreshToken();
            if (result.Ok()) {
                this.$store.commit(sessionKey.AUTH_SUCCESS, result.data);
            }
        },
        goToLogin() {
            this.navigationService.replace(path.login);
        }
    }
});
